"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = void 0;
const winston_1 = __importDefault(require("winston"));
const environment_1 = require("./environment");
const MAXIMUM_LOG_FILE_SIZE = 1000000 * 10; // (10mb);
const logger = winston_1.default.createLogger({
    level: environment_1.LOGGING_LEVEL,
    transports: [
        new winston_1.default.transports.Console()
    ]
});
exports.logger = logger;
